import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import {isActiveToken} from '../mixins/auth';
import Login from "../views/Login/Login";
import Home from "../views/Home/Index";
import UsersList from "../views/Users/List";
import AccountsList from "../views/Accounts/List";
import WithdrawsList from "../views/Withdraws/List";
import MovesList from "../views/Moves/List";
import cfg from '../store/config';


Vue.use(Router);

const ifAuthenticated = (to, from, next) => {
  const role = store.getters['user/getRole'];
  if (role && to.meta && to.meta.access) {
    const defaultRoute = '/withdraws';
    if (!to.meta.access.includes(role)) {
      next(defaultRoute);
      return;
    }
  }
  if (isActiveToken(store.getters['user/getToken'])) {
    next();
    return;
  }
  next('/login');
};

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      beforeEnter: ifAuthenticated,
      component: Home,
      children: [
        {
          path: '',
          beforeEnter: ifAuthenticated,
          component: WithdrawsList,
          meta: {
            access: ['admin', 'superadmin', 'support'],
            title: 'Выводы',
          }
        },
        {
          path: 'withdraws',
          name: 'WithdrawsList',
          beforeEnter: ifAuthenticated,
          component: WithdrawsList,
          meta: {
            access: ['admin', 'superadmin', 'support'],
            title: 'Выводы',
          }
        },
        {
          path: 'accounts',
          name: 'AccountsList',
          beforeEnter: ifAuthenticated,
          component: AccountsList,
          meta: {
            access: ['admin', 'superadmin', 'support'],
            title: 'Аккаунты',
          }
        },
        {
          path: 'users',
          name: 'UsersList',
          beforeEnter: ifAuthenticated,
          component: UsersList,
          meta: {
            access: ['superadmin'],
            title: 'Пользователи',
          }
        },
        {
          path: 'moves',
          name: 'MovesList',
          beforeEnter: ifAuthenticated,
          component: MovesList,
          meta: {
            access: ['admin', 'superadmin', 'support'],
            title: 'Движения',
          }
        },
      ],
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: 'Авторизация',
      }
    },
  ],
});


let DEFAULT_TITLE = cfg.sitePrefix || '';
if (DEFAULT_TITLE) {
  DEFAULT_TITLE += ' - ';
}
router.afterEach((to, from) => {
  Vue.nextTick(() => {
    if (to.meta.title) {
      document.title = `${DEFAULT_TITLE}${to.meta.title}`;
    } else {
      if (DEFAULT_TITLE) {
        document.title = DEFAULT_TITLE;
      } else {
        document.title = 'Frontend';
      }
    }
  });
});

export default router;
